module.exports = {
  env: 'prod',
  PUBLIC_URL: '//s3-us01-public.didiglobal.com/csglobal/cs-workbench-frame/prod/'
}
